import styled from 'styled-components/macro';
import { Menu } from 'antd';
import { BLUE } from 'assets/styles/settings';

export const StyledGroup = styled(Menu.Item)`
    > a {
        display: block;
        padding-left: 16px;
    }
`;

export const StyledMenu = styled(Menu)`
    .ant-menu-item-group-title {
        height: auto !important;
        line-height: 1 !important;
    }
`;

export const StyledSubMenu = styled(Menu.SubMenu)`
    .ant-menu-submenu-arrow {
        display: ${props => (props.hasarrow ? 'block' : 'none')};
    }

    .ant-menu-submenu-title {
        a {
            color: #545454;
            display: flex;

            &.active {
                color: ${BLUE};
            }

            &:hover {
                color: ${BLUE};
            }
        }
    }
`;

export const StyledIcon = styled.i`
    line-height: 42px;
    font-size: 1.987em !important;
    margin-right: 7px !important;
`;

export const StyledTitle = styled.b`
    font-weight: 600;
`;

export const StyledCollapsedTitle = styled.strong`
    font-weight: 500;
    font-size: 1.4em;
    display: block;
    padding-left: 10px;
`;
